import { Campaign } from 'code/MaterialBank/Launches/view/frontend/pages/Banners/types';
import { ColorVariant } from 'components/Cards/ProductCard/ProductCard.types';
import { AttachmentFile } from 'ui-widgets/components/components/FilesList/fileList.types';
import { SnackbarInfo } from './redux';
import { SelectedColorVariants } from '../components/Cards/ResultCard/types';
import { ContentBlockType } from '../containers/SearchResultsContainer/types';
export * from './redux';

export interface ProductCartItem {
  sku: string;
  qty: number;
  project_id: number;
  project_name: string;
  project_type: string;
  quote_id: number;
}

export interface MaterialComponentItem {
  entity_id: number;
  image_url: string;
  name: string;
  position: number;
  sku: string;
  label?: string;
}
export interface SearchMaterialComponentsProps {
  attribute_set?: string;
  component_type?: string;
  items: MaterialComponentItem[];
}

export interface Variant {
  label: string;
  image_url: string;
  [key: string]: any;
}

export interface CurrentConfigData {
  attribute: string;
  label: string;
}
export interface SelectboxConfig {
  attribute: string;
  label: string;
  variants: Variant[];
}
export interface Configurations {
  attribute: string;
  items: MaterialComponentItem[];
  label: string;
  variants: Variant[];
}

export interface VariantsData {
  items: ColorVariant[];
  total_count: number;
}

export interface AnalyticsProps {
  analyticsClass?: string;
  impressions?: string[];
  dataLayerAnalytics?: {
    listId: string;
    listName: string;
    eventLocation: string;
  };
}

export interface ssColor {
  color_name: string;
  entity_id: string | number;
  exact_color: string;
  image_url: string;
  manufacturer_sku: string;
  sku: string;
}
export interface ProductSearchMaterial {
  additionalImages?: string[];
  analyticsClass?: string;
  analyticsData?: AnalyticsProps;
  analyticsPostfix?: string;
  associatedFinishProducts?: string[];
  associatedItem?: string;
  attachments?: AttachmentFile[];
  billingType?: string;
  blurhash?: string;
  brand: string;
  californiaProp65?: string[];
  categories: string[];
  childrenCount?: string;
  color?: string;
  colorVariants?: VariantsData;
  colorwayId?: string;
  components?: SearchMaterialComponentsProps[];
  configData?: {
    color?: string;
    pattern?: string;
    texture?: string;
  };
  configurations: Configurations[];
  content?: string[];
  entityId: string;
  exactColor?: string;
  familyId?: string;
  gridIndex?: number;
  hasAttachments?: boolean;
  id: string;
  imageUrl: string;
  index?: number;
  indoorOutdoorUse?: string[];
  installImages?: string[];
  isCollection?: boolean;
  isColorApplied?: boolean;
  isCompare?: boolean;
  isCustom: boolean;
  isDigital?: boolean;
  isFinish?: boolean;
  isGeoRestricted: boolean;
  isProjectRestricted: boolean;
  isUnavailable: boolean;
  isGpsCompliant?: boolean;
  isInRealTimeStock?: boolean;
  isInStock: boolean;
  isJustAdded: boolean;
  isNew: boolean;
  isOrderable?: boolean;
  isPaint?: boolean;
  isParent?: boolean;
  isPrimary?: boolean;
  isProduct?: boolean;
  isProducts?: boolean;
  itemType?: string;
  lightReflectanceValue?: string;
  manufacturer: string;
  manufacturerSku?: string[];
  name: string;
  originalMaterial: any;
  originRequestId?: string;
  paintProductType?: string;
  parentEntityId?: string;
  priceRange?: string;
  priceSign?: string;
  productFinishType?: string;
  productType?: string;
  primaryChildId?: string;
  qty?: string;
  qvLocation?: string;
  residentialCommercial?: string[];
  sampleNote?: string;
  selectedColorFilterEntityId?: string;
  sibling?: any[];
  siblings?: any[];
  siblingIds?: string[];
  sizeNote?: string;
  sku: string;
  ssFacetColorFilter?: ssColor[];
  ssItemType?: string;
  ssStatePermission?: string[];
  taxonomy?: string[];
  taxonomyL2?: string[];
  taxonomyL2Display?: string;
  thumbnailImageUrl: string;
  title?: string;
  unitsOfMeasure?: string;
  url: string;
  visibility?: string;
  sampleType?: string;
}

export enum ResponseStatusEnum {
  FAILED = 'failed',
  SUCCESS = 'success',
}

export interface FilterDataValues {
  active?: boolean;
  count?: number;
  label: string;
  field?: string;
}
export interface FilterData {
  active?: boolean;
  count?: number;
  field: string;
  id: string;
  label: string;
  parent?: string;
  value?: any;
  values?: FilterDataValues[];
  parentsLabel?: string;
  high?: number;
  low?: number;
  visible?: boolean;
  collapse?: boolean;
  multiple?: string;
}

export interface CollectionItem {
  _id: string;
  blurhash: string;
  categories: [];
  children_count: number;
  children_ids: string[];
  description: string;
  entity_id: string;
  is_geo_restricted: boolean;
  name: string;
  ss_item_type: string[];
  taxonomy_l2: string[];
  thumbnailImageUrl: string;
  url_key: string;
  visibility: string;
}

export interface Category {
  category_id: string;
  label: string;
  parent_id: string;
  created_at: string;
  position: string;
  level: string;
}

export interface CollectionsResponse {
  status: string;
  campaigns: Campaign[];
  categories: Category[];
  total_items: number;
}

export interface Collection extends Category {
  campaigns: Campaign[];
}

export interface CampaignBanner {
  position: 'header' | 'content' | 'footer';
  banner: Campaign;
}

export interface SearchOption {
  query?: string;
  page?: number;
  action?: string;
  sortBy?: string;
  residentialCommercial?: string | null;
}

export type Launch = {
  campaign_id: string;
  template: string;
  title: string;
  subtitle: string;
  description: string;
  start_date: string;
  end_date: string;
  url: string;
  image: string;
  priority: string;
  image_url: string;
  content?: string;
  content_color?: string;
  button_text?: string;
  button_color?: string;
  line1?: string;
  line1_color?: string;
  hero_image?: string;
  hero_image_mobile?: string;
};

interface CompareApiKeys {
  [key: string]: string;
}
export interface SearchSliceState {
  productWithFilePreviewInQueue?: ProductSearchMaterial;
  results?: ProductSearchMaterial[];
  contentBlocks?: ContentBlockType[];
  pagination?: {
    currentPage: number;
    perPage: number;
    totalPages: number;
    totalResults: number;
  };
  searchOptions?: SearchOption;
  isSearching?: boolean;
  isFetching?: boolean;
  isGridMode?: boolean;
  xRequestId?: string;
  xSessionId?: string;
  contentBlockXRequestId?: string;
  campaignBanners?: CampaignBanner[];
  materialsInQueue?: [];
  isSearchQueryRelaxed?: boolean;
  isSearchRedirect?: boolean;
  collectionHeader?: {
    name: string;
    description: string;
    additional_images: string[];
  };
  selectedVariants?: SelectedColorVariants;
  stripMaterials?: ProductSearchMaterial[];
  isStripMaterialsLoading?: boolean;
}

export interface FilterSliceState {
  currentFilters?: FilterData[];
  appFilters: AppFiltersProps;
  searchToggle?: string;
  multiSelectToggle?: boolean;
  selectAllToggle?: boolean;
  selectedMaterials?: ProductSearchMaterial[];
  overrideParams?: Record<string, unknown>;
  isFilterShown?: boolean;
  isFiltersDrawerShown?: boolean;
  isColorCircleTopbarShown?: boolean;
  isBrandSwitch?: boolean;
  isRainbowClicked?: boolean;
  mobileActiveFilters?: FilterData[];
  isRepToolEnabled?: boolean;
  taxonomyFilterValue?: string;
  additionalFilters?: Record<string, unknown>;
}

export interface SearchSortingSliceState {
  sortingList: SortOption[];
  currentSortOption?: SortOption;
}
export interface ProjectsSliceState {
  isProjectModalOpen: boolean;
  projectModalEventLocation: string;
}
export interface LaunchesSliceState {
  launches: Launch[] | null;
}
export interface CommonSliceState {
  cartItems: CartItem[];
  createPaletteModalOpened: boolean;
  currentCollectionTitle: string;
  errorMessage: {
    body: string | null;
    showCancelButton: boolean;
    shouldDisableBottomPadding: boolean;
    title: string | null;
  };
  isExportModalOpen: boolean;
  isContentBlocksModalOpen: boolean;
  isCMSModalOpen: {
    id: string;
    status: boolean;
  };
  activeContentBlock: any;
  isSearchLite: boolean;
  snackbarInfo: SnackbarInfo;
  isComparisonActive: boolean;
  isCompareTableShown: boolean;
  comparisonItems: ProductSearchMaterial[];
  compareApiResults: ProductSearchMaterial[];
  compareApiKeys: CompareApiKeys | undefined;
}
export interface SearchGlobalStateType {
  search: SearchSliceState;
  filters: FilterSliceState;
  searchSorting: SearchSortingSliceState;
  projects: ProjectsSliceState;
  launches: LaunchesSliceState;
  common: CommonSliceState;
}

export type CurrentProdjectCookieType = {
  project_id: number;
  type: string;
  title: string;
  type_name: string;
};
export interface RelatedProduct {
  title: string;
  id: string | number;
}

export type AddToBagProps = {
  materials: ProductSearchMaterial[];
  projectId?: string | number;
  // TODO: optmize the type and the function that uses it
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  project?: any;
  relatedProductData?: RelatedProduct;
  triggerLocation?: string;
  isFinishMaterial?: boolean;
  shouldTriggerModal?: boolean;
  customSuccessMessage?: Pick<SnackbarInfo, 'messagePayload' | 'messageType'>;
  onSuccess?: () => void;
  additionalSplitProperties?: Record<string, any>;
  additionalAnalyticsProperties?: Record<string, any>;
  customSplitEvents?: unknown[];
};
export interface AppFiltersProps {
  [key: string]: FilterData;
}

export interface SortOption {
  direction: string;
  field: string;
  label: string;
}

export interface ApiRawMaterial {
  product_finish_type?: string;
  paint_product_type?: string;
  is_new?: boolean;
  is_orderable?: boolean;
  is_products?: boolean;
  is_geo_restricted?: boolean;
  is_project_restricted?: boolean;
  is_unavailable?: boolean;
  just_added?: boolean;
  in_stock?: string;
  id: string;
  children_count?: string;
  california_prop_65?: string[];
  isInRealTimeStock?: boolean;
  entity_id: string;
  ss_state_permission?: string[];
  manufacturer?: string;
  manufacturer_sku?: string[];
  product_type?: string;
  qty?: string;
  residential_commercial?: string[];
  imageUrl?: string;
  name?: string;
  sku?: string;
  brand_name?: string[];
  url?: string;
  siblings?: any[];
  categories?: string[];
  ss_facet_color_filter?: any[];
  indoor_outdoor_use?: string[];
  price_sign?: string;
  color?: string;
  thumbnailImageUrl?: string;
  item_type?: string;
  configurations?: any[];
  blurhash?: string;
  components?: any[];
  _colorway_id?: string;
  ss_item_type?: string;
  associated_finish_products?: string[];
  family_id?: string;
  taxonomy?: string[];
  light_reflectance_value?: string;
  is_primary?: boolean;
  sample_note?: string;
  sample_type?: string;
  is_finish?: boolean;
  is_paints?: boolean;
  color_variants?: VariantsData;
  attachments?: AttachmentFile[];
  taxonomy_l2?: string[];
  is_digital?: boolean;
  has_attachments?: boolean;
  visibility?: string;
  is_collection?: boolean;
  is_gps_compliant?: boolean;
  size_notes?: string;
  additional_images?: string[];
  install_images?: string[];
  content_textile?: string[];
  price_range_verbose?: string;
  pricing_unit_of_measure?: string;
  billing_type?: string;
  primary_child_id?: string;
}

export interface CartItem {
  entityId: string;
  time: number;
}
